// extracted by mini-css-extract-plugin
export var cardContainer = "_ni-0";
export var cardHeader = "_ni-2";
export var collapsedState = "_ni-3";
export var dragHandle = "_ni-5";
export var dragHandleIcon = "_ni-6";
export var dragging = "_ni-1";
export var titleArea = "_ni-4";